export default __webpack_public_path__ + "static/team-1-6d94c348a025f2f1465990c414a8094b.jpg";